module.exports = __webpack_public_path__ + "media/images/pattern-tartan.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pattern-tartan.png
// module id = 74
// module chunks = 0